<p-card [attr.data-auto-id]="autoIdBase">
  <p-accordion value="1">
    <p-accordion-panel class="border-none" value="1">
      <p-accordion-header>
        <div class="flex align-items-center gap-2">
          <img src="assets/icons/cinch_icon_home.svg" width="45px" height="45px" alt="ReKey icon">
          <p class="text-base text-slate-950 custom-bold m-0">ReKey®</p>
        </div>
      </p-accordion-header>
      <p-accordion-content>
        <p class="mt-0">
          Request to have your new home's locks professionally re-keyed by a Cinch preferred vendor.
        </p>

        <div>
          <h4 class="custom-bold">About Re-Key Service</h4>
          <p>
            Rekey Service is available one time during the term of the Plan and includes the rekey
            of up to 6 keyholes (including deadbolts) and 4 copies of the key(s) total.
            Contact the Re-Key vendor directly to schedule service. Payment is due directly to the vendor at the
            time of service.
          </p>
        </div>

        <div>
          <form [formGroup]="zipSearchForm" autocomplete="off" (ngSubmit)="reKeySearch()" [id]="autoIdBase + '-zip-form'">
            <p>Enter your ZIP code below to find the Cinch preferred Re-Key vendor in your area.</p>

            <div class="p-fieldset">
              <label [for]="autoIdBase + '-zipcode'">Zip Code</label>
              <div
                *ngIf="zipSearchForm.controls['zipCode'].touched && zipSearchForm.controls['zipCode'].errors?.['required']"
                class="required text-orange-900">
                <span class="bg-orange-100"><i class="pi pi-exclamation-triangle"></i> Required</span>
              </div>
              <input [id]="autoIdBase + '-zipcode'" type="text" pInputText class="w-full"
                formControlName="zipCode" [attr.data-auto-id]="autoIdBase + '-zipcode'"
                [attr.aria-describedby]="autoIdBase + '-zipcode-help'" />
              <small [id]="autoIdBase + '-zipcode-help'"
                *ngIf="zipSearchForm.controls['zipCode'].invalid && (zipSearchForm.controls['zipCode'].dirty || zipSearchForm.controls['zipCode'].touched)"
                class="mt-1 text-rose-600" [attr.data-auto-id]="autoIdBase + '-zip-validation-error'">
                Please enter a valid zip code
              </small>
            </div>

            <p-button type="submit" [disabled]="zipSearchForm.invalid || searchingVendor"
              [attr.data-auto-id]="autoIdBase + '-submit-zip-code'" [rounded]="true" severity="primary"
              class="flex align-items-center justify-content-center w-full pt-4" styleClass="w-full">
              <ng-container *ngIf="searchingVendor">
                <i class="pi pi-spin pi-spinner"></i>&nbsp;Searching for vendors
              </ng-container>
              <ng-container *ngIf="!searchingVendor"> Submit </ng-container>
            </p-button>
          </form>
        </div>

        <div *ngIf="vendorData && vendorData.length" class="pt-4">
          <div>
            <h4 class="custom-bold">Vendors Available ({{vendorData.length}})</h4>
            <p>Note: Please contact the vendor directly to schedule Re-Key service.</p>
          </div>

          <div *ngFor="let vendor of vendorData; let i = index; trackBy: trackByIndex">
            <div class="flex flex-column p-0">
              <span [attr.data-auto-id]="autoIdBase + '-vendor-name-' + i">Company Name: &nbsp;{{vendor.vendorName}}</span>
              <span [attr.data-auto-id]="autoIdBase + '-vendor-phone-' + i">
                Phone #: <span [innerHTML]="vendor.vendorPhone | phone:true" class="vendor-phone"
                  appGaButtonClick [buttonLocation]="pageLocation" [buttonName]="vendorButtonName"></span>
              </span>
              <span [attr.data-auto-id]="autoIdBase + '-vendor-email-' + i">Email: &nbsp;{{vendor.vendorEmail}}</span>
            </div>
          </div>
        </div>

        <div *ngIf="vendorData && !vendorData.length && !searchingVendor && !vendorError" class="pt-4">
          <div class="flex flex-row w-full">
            <img src="assets/icons/location-not-available.png" class="vendor-not-found-image pr-2" />
            <div class="flex flex-column">
              <strong>Sorry! No vendors found.</strong>
              <span class="pt-2">We have no vendors available in your service area at this time.</span>
            </div>
          </div>
        </div>

        <div *ngIf="vendorError" class="pt-4">
          <p-message severity="error" styleClass="w-full" icon="pi pi-ban" closable>
            <div class="flex flex-column">
              <strong>Oops!</strong>
              <span class="pt-2">We're having a technical issue retreiving vendor info. Please try again
                later.</span>
            </div>
          </p-message>
        </div>
      </p-accordion-content>
    </p-accordion-panel>
  </p-accordion>
</p-card>
